// Variantes observadas en las descripciones del catálogo de artículos.
// Las reglas fuertes tienen prioridad sobre las abreviaturas contextuales L/R y LT/RT.
// No se incluyen LHD/RHD ni DRIVER/PASSENGER porque describen la configuración del
// vehículo y no determinan de forma inequívoca el lado físico de la pieza.
export const LADO_ARTICULO_DICCIONARIO = Object.freeze({
  LH: Object.freeze({
    fuerte: Object.freeze([
      // LH, LH1, LH2 y compuestos que terminan en LH: FLH, RLH, MLH, BRACKETLH.
      /LH(?:[12])?(?:[^A-Z0-9]|$)/,
      // Español: IZQ, IZQUIER, IZQUIERD, IZQUIERDA e IZQUIERDO.
      /(^|[^A-Z])IZQ(?:UIER(?:D(?:A|O)?)?)?(?:[^A-Z]|$)/,
      // Inglés: LEFT y LEFT HAND.
      /(^|[^A-Z])LEFT(?:[^A-Z]|$)/,
    ]),
    contextual: Object.freeze([
      // Abreviatura inglesa Left. Se evalúa solo si no hubo una regla fuerte.
      /(^|[^A-Z0-9])LT(?:[^A-Z0-9]|$)/,
      // Letra L aislada. Se excluyen expresamente formas combinadas como R/L.
      /(^|[^A-Z0-9/])L(?:[^A-Z0-9/]|$)/,
    ]),
  }),
  RH: Object.freeze({
    fuerte: Object.freeze([
      // RH, RH1, RH2 y compuestos que terminan en RH: FRH, RRH, MRH, BRACKETRH.
      /RH(?:[12])?(?:[^A-Z0-9]|$)/,
      // Español: DER, DERECH, DERECHA y DERECHO.
      /(^|[^A-Z])DER(?:ECH(?:A|O)?)?(?:[^A-Z]|$)/,
      // Inglés: RIGHT, RIGHT HAND y la forma truncada RIGH observada en el catálogo.
      /(^|[^A-Z])(?:RIGHT|RIGH)(?:[^A-Z]|$)/,
    ]),
    contextual: Object.freeze([
      // Abreviatura inglesa Right. Se evalúa solo si no hubo una regla fuerte.
      /(^|[^A-Z0-9])RT(?:[^A-Z0-9]|$)/,
      // Letra R aislada. Se excluyen expresamente formas combinadas como R/L.
      /(^|[^A-Z0-9/])R(?:[^A-Z0-9/]|$)/,
    ]),
  }),
});

const AMBOS_LADOS = Object.freeze([
  /(^|[^A-Z0-9])R\s*\/\s*L(?:[^A-Z0-9]|$)/,
  /(^|[^A-Z0-9])L\s*\/\s*R(?:[^A-Z0-9]|$)/,
  /(^|[^A-Z])DER\s*\/\s*IZQ(?:[^A-Z]|$)/,
  /(^|[^A-Z])IZQ\s*\/\s*DER(?:[^A-Z]|$)/,
]);

const SECUENCIA_LETRAS_AISLADAS = /(?:^|\s)(?:[A-Z]\s+){2,}[A-Z](?:\s|$)/;

function normalizarNombre(nombre) {
  return String(nombre || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .trim();
}

function coincideAlguna(nombre, patrones) {
  return patrones.some((patron) => patron.test(nombre));
}

// Devuelve "LH", "RH" o "". Ante ausencia, conflicto o una descripción para ambos lados,
// no asigna nada: el componente deja visible solamente el código original del artículo.
export function obtenerLadoPorNombreArticulo(nombreArticulo) {
  const nombre = normalizarNombre(nombreArticulo);
  if (!nombre || coincideAlguna(nombre, AMBOS_LADOS)) return '';

  const lhFuerte = coincideAlguna(nombre, LADO_ARTICULO_DICCIONARIO.LH.fuerte);
  const rhFuerte = coincideAlguna(nombre, LADO_ARTICULO_DICCIONARIO.RH.fuerte);
  if (lhFuerte || rhFuerte) return lhFuerte === rhFuerte ? '' : (lhFuerte ? 'LH' : 'RH');

  const lhContextual = coincideAlguna(nombre, LADO_ARTICULO_DICCIONARIO.LH.contextual);
  const rhContextual = coincideAlguna(nombre, LADO_ARTICULO_DICCIONARIO.RH.contextual);

  // Evita falsos positivos de descripciones que deletrean una palabra con letras aisladas,
  // como "PILAR C R E M A" o "PILAR G R I S".
  if (SECUENCIA_LETRAS_AISLADAS.test(nombre)) return '';
  return lhContextual === rhContextual ? '' : (lhContextual ? 'LH' : 'RH');
}
